import React, { Component } from 'react';
import axios from "axios";
import Api from "../../customlib/Api";
import moment from "moment";
import Global from "../../customlib/Global"


import { makeStyles } from '@mui/styles';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton, Box, Typography, CircularProgress, ToggleButtonGroup, ToggleButton, TextField, Chip, Button, Grid} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import ExportCheckPointReport from './ExportCheckPointReport';
import { ConnectWithoutContact, RefreshRounded, Groups, WbSunny, LightMode, Bedtime } from '@mui/icons-material';

class LoginMonitoring extends Component {
    SHIFT_PAGI = "PAGI";
    SHIFT_SIANG = "SIANG";
    SHIFT_MALAM = "MALAM";
    state = { 
        loginLogs : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        page: 0,
        rowsPerPage: 30,
        appProfileId: "",
        dateRangeValue: [null,null],
        isLoading: false,
        shift: this.SHIFT_PAGI
    }
    
    componentDidMount() {
        this.setState(
          {appProfileId: Global.getAppProfile()._id}, ()=>{
            this.getLoginLogs();
          }
        );
    }

    getLoginLogs = () => {
        console.log("STARTDATE : ",this.state.startDate);
        var userData = Global.get();
        console.log("USERDATA : ", userData);
        console.log("USERDATA", userData);

        const params = {
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          appProfileId: this.state.appProfileId,
          shift: this.state.shift
          // token: "07d0b91e771752005d94ceb5c5efdc0a"
        }

        this.setState({loginLogs: [], isLoading: true}, () => {
            axios
            .post(Api.loginMonitoring(), params, Api.getRequestHeader())
            .then((response) => {
                console.log("loginLogs : ", response.data);
                
                var tmpLogs = response.data.data.logs;

                let formatted = [];

                tmpLogs.forEach(log => {
                    let existedLog = formatted.find(item => log.lavenderUserId === item.userId);

                    if(existedLog){
                        existedLog.rows.push(log);
                        existedLog.lastLoginState = log.state;
                    }else{
                        formatted.push({
                            userId: log.lavenderUserId,
                            userName: log.name,
                            lastLoginState: log.state,
                            rows: [
                                log
                            ]
                        });
                    }

                });
                
                this.setState({loginLogs: formatted, isLoading: false});
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
        });

      };

    handleStartDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ startDate:  formatStartDate}, this.getLoginLogs);
        // this.state.startDate = formatStartDate;
        // this.getloginLogs();
        // console.log(this.state.email);
    };

    handleEndDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ endDate:  formatStartDate}, this.getLoginLogs);
        // this.getloginLogs();
        // console.log(this.state.email);
    };

    handleDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDate: startDate, endDate:  endDate}, this.getLoginLogs);
    }

    handleSetNewDateValue = (newDateValue) => {
      this.setState({dateRangeValue: [...newDateValue],});
    }

    handleChangeShift = (event, value) => {
      this.setState({shift: value}, () => {
        this.getLoginLogs();
      });
    }

    render() {
        const { loginLogs, isLoading, shift, startDate } = this.state;
        const onlineCount = loginLogs.filter(item => item.lastLoginState === "ONLINE").length;

        return (
            <Box sx={{ p: 0 }}>
                <Paper variant="outlined" sx={{ borderRadius: "10px", p: 2, mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Groups sx={{ fontSize: 26, color: "primary.main" }} />
                                <Box>
                                    <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2 }}>{loginLogs.length}</Typography>
                                    <Typography variant="caption" color="text.secondary">Jumlah User</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Chip
                                icon={<ConnectWithoutContact sx={{ fontSize: 18 }} />}
                                label={`${onlineCount} Online`}
                                color={onlineCount > 0 ? "success" : "default"}
                                sx={{ fontWeight: 700, px: 1 }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <ToggleButtonGroup
                                color="primary"
                                value={shift}
                                exclusive
                                size="small"
                                onChange={this.handleChangeShift}
                                aria-label="Shift"
                                fullWidth
                            >
                                <ToggleButton value={this.SHIFT_PAGI} sx={{ textTransform: "none" }}><WbSunny sx={{ fontSize: 16, mr: 0.5 }} /> Pagi</ToggleButton>
                                <ToggleButton value={this.SHIFT_SIANG} sx={{ textTransform: "none" }}><LightMode sx={{ fontSize: 16, mr: 0.5 }} /> Siang</ToggleButton>
                                <ToggleButton value={this.SHIFT_MALAM} sx={{ textTransform: "none" }}><Bedtime sx={{ fontSize: 16, mr: 0.5 }} /> Malam</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid item xs={8} sm={9} md={2}>
                            <TextField
                              id="tanggal"
                              label="Tanggal"
                              value={startDate}
                              onChange={(event) => {
                                let selectedDate = event.target.value;
                                this.setState({startDate: selectedDate, endDate: selectedDate}, () => {
                                  this.getLoginLogs();
                                });
                              }}
                              type="date"
                              size='small'
                              fullWidth
                            />
                        </Grid>
                        <Grid item xs={4} sm={3} md={1}>
                            {
                                isLoading === true ?
                                    <Box sx={{ display: "flex", justifyContent: "center" }}><CircularProgress size={28} /></Box> :
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        onClick={() => {this.getLoginLogs()}}
                                        sx={{ minWidth: 0, borderRadius: "8px" }}
                                    >
                                        <RefreshRounded />
                                    </Button>
                            }
                        </Grid>
                    </Grid>
                </Paper>

                <Paper variant="outlined" sx={{ borderRadius: "10px" }}>
                    <TableContainer>
                        <Table aria-label="sticky table" size='small'>
                        <TableHead>
                            <TableRow sx={{ "& th": { fontWeight: 700, bgcolor: "#f5f5f5" } }}>
                                <TableCell width="20px" />
                                <TableCell>User</TableCell>
                                <TableCell>Login Count</TableCell>
                                <TableCell>Last Login State</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loginLogs.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>
                                            {isLoading ? "Memuat data..." : "Tidak ada data login."}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                            {loginLogs.map((row) => {
                            return (
                                <Row key={row.userId} row={row} />
                            );
                            })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
         );
    }
}
 
export default LoginMonitoring;

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
});

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
  
    const isOnline = row.lastLoginState === "ONLINE";

    return (
      <React.Fragment>
        <TableRow className={classes.root} hover>
          <TableCell width="20px">
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.userName}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.rows.length}
          </TableCell>
          <TableCell component="th" scope="row">
            <Chip
              icon={<ConnectWithoutContact sx={{ fontSize: 16 }} />}
              label={isOnline ? "ONLINE" : "OFFLINE"}
              color={isOnline ? "success" : "default"}
              size="small"
              sx={{ fontWeight: 700 }}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: open ? undefined : "none" }} colSpan={4}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ m: 1, bgcolor: "#fafafa", borderRadius: "8px", p: 1 }}>
                <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ pl: 1 }}>
                  Riwayat Login
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>Login</strong></TableCell>
                      <TableCell><strong>Logout</strong></TableCell>
                      <TableCell><strong>Status</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.rows.map((historyRow) => (
                      <TableRow key={historyRow.id}>
                        <TableCell align='left'>
                          {Global.formatDateTimeToStrDateTime24(historyRow.created_at)}
                        </TableCell>
                        <TableCell align="left">
                            {historyRow.logoutTime ? Global.formatDateTimeToStrDateTime24(historyRow.updated_at) : "--:--:--"}
                        </TableCell>
                        <TableCell align='left'>{historyRow.state}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }